import React, { useEffect, useState } from 'react';
import { useJob } from '../components/JobProvider'
import FileUploader from '../components/FileUploader';
import UploadedFileView from '../components/UploadedFileView';
import ModalMaterialsWelcome from '../components/ModalMaterialsWelcome';
import styles from './Upload.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import TopBarProgress from "react-topbar-progress-indicator";
import { useAuth } from '../components/AuthProvider';

TopBarProgress.config({
  barColors: {
    "0": "#8bd1ff",
    "1.0": "#00a9ec"
  },
  shadowBlur: 5,
  barThickness: 10
});

export default function Upload() {
  const [uploadData, setUploadData] = useState([]);
  const search = window.location.search
  const [clientName, setClientName] = useState(null);
  const { jobId: job } = useJob() || {}
  const [snapshotJob, setSnapshotJob] = useState();
  const { token } = useAuth()
  const [uploadPending, setUploadPending] = useState(false);

  const queryString = (React.useMemo(() => new URLSearchParams(search), [search])).get("h");

  const handleFileUploaderCallback = (data) => {
    setUploadPending(true);
    const formData = new FormData();
    formData.append("jobId", snapshotJob.jobId);
    for (let i = 0; i < data.length; i++) {
      formData.append("files[" + i + "]", data[i]);
      formData.append("documentNames[" + i + "]", data[i].name);
    }
    if (queryString) {
      fetch(`${process.env.REACT_APP_API_URL}/data/audit_material/${queryString}`, {
        body: formData,
        method: 'POST'
      }).then(res => res.json())
        .then(docs => {
          const uploadedDocs = [];
          docs.map(d => uploadedDocs.push({ id: d.documentId, name: d.fileName, size: d.size, url: d.url, docName: d.documentName }));
          setUploadData(uploadedDocs);
          console.log(uploadedDocs);
          setUploadPending(false)
        },
          (error) => {
            console.log(error);
          });
    }
    else if (job) {
      fetch(`${process.env.REACT_APP_API_URL}/data/multipart_document`, {
        body: formData,
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then(res => res.json())
        .then(docs => {
          const uploadedDocs = [];
          docs.map(d => uploadedDocs.push({ id: d.documentId, name: d.fileName, size: d.size, url: d.url, docName: d.documentName }));
          setUploadData(uploadedDocs);
          console.log(uploadedDocs);
          setUploadPending(false)
        },
          (error) => {
            console.log(error);
          });
    }
  }

  const handleFileViewCallback = (id) => {
    if (queryString) {
      fetch(`${process.env.REACT_APP_API_URL}/data/audit_material/${queryString}/${id}`, {
        method: 'DELETE'
      })
        .then(res => res.json)
        .then(() => {
          setUploadData(uploadData.filter(file => file.id !== id));
        })
    }
    else if (job) {
      fetch(`${process.env.REACT_APP_API_URL}/data/document/${id}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
        .then(res => res.json)
        .then(() => {
          setUploadData(uploadData.filter(file => file.id !== id));
        })
    }
  }

  // Pull the job data from the hash provided in the query string or use the currently logged in user's job id
  useEffect(() => {
    if (queryString) {
      fetch(`${process.env.REACT_APP_API_URL}/data/audit_material/${queryString}`)
        .then(res => res.json())
        .then(
          (result) => {
            setClientName(result.job.client?.clientName);
            setSnapshotJob(result.job);
          },
          (error) => {
            console.log(error);
          }
        )
    } else if (job) {
      fetch(`${process.env.REACT_APP_API_URL}/data/job/${job}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
        .then(res => res.json())
        .then(
          (job) => {
            setClientName(job.client?.clientName);
            setSnapshotJob(job)
          }
        )
    }
  }, [queryString, job, token]);

  return (
    <>
      <ModalMaterialsWelcome companyName={clientName} />
      <Container className="mt-3">
        <Row>
          <Col xs={12} className="d-flex justify-content-between align-content-center">
            <h1 className="mb-0">SpyGlass Materials Upload</h1>
          </Col>
        </Row>
      </Container>
      <Container className="mt-3 mb-3">
        <Row>
          <Col xs={12} lg={3} className="mt-lg-0">
            <Card className="card-h-100">
              <Card.Body>
                <div className="cardTitleContainer">
                  <Card.Title className="d-flex align-items-center">
                    <div className="circleNumber me-2 bg-primary color-white">1</div> Select Your Files
                  </Card.Title>
                </div>
                <Card.Text>
                  Drag and Drop your files into the blue box below or alternatively,
                  click the white “Choose Files” button to select the files you want to attach.
                  Select more than one file by holding Shift or Ctrl as you select. Once your selection is made, click Open.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} lg={3} className="mt-3 mt-lg-0">
            <Card className="card-h-100">
              <Card.Body>
                <div className="cardTitleContainer">
                  <Card.Title className="d-flex align-items-center">
                    <div className="circleNumber me-2 bg-primary color-white">2</div>
                    <span className="ls-n3">Review Your Selected Files</span>
                  </Card.Title>
                </div>
                <Card.Text>
                  The files to be uploaded will be displayed below. Review for accuracy.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} lg={3} className="mt-3 mt-lg-0">
            <Card className="card-h-100">
              <Card.Body>
                <div className="cardTitleContainer">
                  <Card.Title className="d-flex align-items-center">
                    <div className="circleNumber me-2 bg-primary color-white">3</div>
                    Upload Your Files
                  </Card.Title>
                </div>
                <Card.Text>
                  Select the blue “Upload” button to submit the files to SpyGlass.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} lg={3} className="mt-3 mt-lg-0">
            <Card className="card-h-100">
              <Card.Body>
                <div className="cardTitleContainer">
                  <Card.Title className="d-flex align-items-center">
                    <div className="circleNumber me-2 bg-primary color-white">4</div>
                    Confirm Your Uploads
                  </Card.Title>
                </div>
                <Card.Text>
                  Wait for the upload progress bar to complete and the confirmation message to display.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card>
              <Card.Body>
                <div className="cardTitleContainer">
                  <Card.Title>File Upload</Card.Title>
                </div>
                <Card.Text>
                  <span className="color-warning pe-1"><FontAwesomeIcon icon="exclamation-circle" /></span>The total size of the files must be less than 1 GB for each attempt. You can upload more than 1 GB with multiple attempts
                </Card.Text>
                {uploadPending ? <div style={{display: 'flex', justifyContent: 'center', fontWeight: 'bold'}}><TopBarProgress />Uploading...</div> : (
                  <div>
                    <FileUploader callback={handleFileUploaderCallback} />
                    {uploadData.length > 0
                      ? <div style={{marginTop: '1em'}}>
                        <h3>Uploaded Successfully</h3>
                        <div className={styles.uploadedFileContainer}>
                          {uploadData.map((file, index) => <UploadedFileView callback={handleFileViewCallback} file={file} key={index} />
                          )}
                        </div>
                      </div>
                      : <></>}
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}